export default {
      id: "limit_date-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#limit_date-usage",
      toString: function () {
        return this.url;
      }
    }